<template lang="pug">
  .continued
    .container
      .link
        h5 持续刷新 永不毕业
        a(v-bind:href="link" target="_blank")
          | 会员申请
          .triangle-right
      p
        | 一个持续刷新的「学习机制」<br>
        | 全球TOP 20学府权威前沿学者的顾问团和科研网络<br>
        | 世界级科技公司顶层资源和交流机制<br>
        | 中国优秀创业公司创始人的群落和有效率的沟通<br>
        | 极客公园对产业趋势的专业判断和全球资源能力<br>
        | 每年引导最有价值的主题和人，创造持续的交流价值
</template>

<script>
export default {
  data() {
    return {
      link: 'http://cn.mikecrm.com/J6cZ7QZ'
    }
  }
}
</script>

<style lang="stylus">
@import '../assets/css/var'
.continued
  background #161616
  color #fff
  .container
    padding-top 50px
    padding-bottom 50px
  .link
    width 50%
    display inline-block
    vertical-align top
    h5
      font-size 40px
      margin-bottom 60px
      font-family 'Noto Sans SC', sans-serif
      font-weight 300
    a
      color #5EC5FF
      display inline-block
      border 0.1em solid currentColor
      padding 0.5em 2em
      font-size 24px
      font-weight bolder
      &:hover
        color #000
        background-color #5EC5FF
        border-color #5EC5FF
  p
    display inline-block
    width 50%
    line-height 1.8em
    font-size 16px
    text-align right
@media $media
  .continued
    .link
      width 100%
      text-align center
      h5
        font-size 28px
        margin-bottom 0px
      a
        margin-top 30px
        margin-bottom 40px
    p
      width auto
      font-size 12px
      text-align left
</style>



// WEBPACK FOOTER //
// FooterUser.vue?014977b1